
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile-app-development-company",
      function () {
        return require("private-next-pages/mobile-app-development-company.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile-app-development-company"])
      });
    }
  